import BaseModel from "./BaseModel";
import { EntityTypeId } from "../util/EntityTypeId";
import OrphyNetwork from "../network/orphyNetwork";

export default class AppModel extends BaseModel {
    constructor() {
        super(new OrphyNetwork());
    }

    protected contactNoteBoundToMail(uuid: string): boolean {
        return false;
    }

    protected logoutInvisible(): boolean {
        return true;
    }

    protected todoBoundToMail(uuid: string): boolean {
        return false;
    }

    protected async addContactNoteCategory(uuid: string) {
        Promise.resolve();
    }

    protected async addTodoCategory(uuid: string) {
        Promise.resolve();
    }

    protected async getSubject(): Promise<string> {
        return "";
    }

    protected async getEmailAddress(allowShowChooser:boolean= true): Promise<string> {
        return "";
    }

    public reloadPlugin = async () => {
        await this.refreshPlugin();
    };

    protected async setAttachments(): Promise<void> {}

    protected async handleAttachmentUpload(uuid: string, entityTypeId: EntityTypeId): Promise<boolean> {
        return false;
    }

    protected ccAndToButtonsVisible(): boolean {
        return false;
    }

    protected addParticipantButtonVisible(): boolean {
        return false;
    }

    /**
     * capture="environment" only replaces the file dialog with the camera where the OS
     * offers a camera app for it - that is Android and iOS.
     * "pointer: coarse" alone is not enough: a Windows tablet without a mouse reports it
     * too but has no such app, so "take photo" would open a file dialog there. That is
     * exactly where the webcam capture works instead.
     */
    protected cameraCaptureVisible(): boolean {
        const coarsePointer = !!window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
        return coarsePointer && AppModel.isMobileOs();
    }

    /**
     * navigator.platform is deprecated but present everywhere - and the only one of the
     * relevant signals that Chrome device emulation does not fake. Emulation therefore
     * behaves like the desktop it runs on.
     */
    private static isMobileOs(): boolean {
        const platform = navigator.platform || "";

        // iPadOS reports itself as Macintosh, only the touch points give it away
        if (platform === "MacIntel" && navigator.maxTouchPoints > 1) {
            return true;
        }

        if (/^(Win|Mac|Linux x86|Linux i686|FreeBSD|OpenBSD|CrOS)/.test(platform)) {
            return false;
        }

        // Android reports "Linux armv8l"/"Linux aarch64" and falls through to here
        const uaData = (navigator as any).userAgentData;
        if (uaData && typeof uaData.mobile === "boolean") {
            return uaData.mobile;
        }

        return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    }

    /**
     * Live webcam capture. Allowed because the app is its own top level document.
     * Not on touch devices: there capture is the better source.
     */
    protected webcamCaptureAllowed(): boolean {
        return !this.cameraCaptureVisible();
    }
}
